<script lang="ts">
  import Hero3Form from './Hero3Form.svelte';
  import { BulletPoint } from '../../components/index';
  import './css/hero3.scss';
  import type { Hero3 } from '../types';
  import type { MktSettings } from 'customer-components/lib/types';
  import PricingTag from './_PricingTag.svelte';

  export let properties: Hero3;
  export let settings: MktSettings;

  $: ({
    callouts,
    headline,
    subHeadline,
    description,
    image,
    items,
    currentStep,
    caption,
    pricingTag,
  } = properties);
  if (typeof currentStep != 'number') currentStep = 1;
  $: ({ phoneNumber } = settings);
  let formSent = false;

  console.log(properties);
</script>

<section class="hero4">
  <div class="hero-img">
    <img src={image?.value} alt="hero-img" />
  </div>
  <div class="wrapper">
    <div class="hero-content">
      <div>
        {#if pricingTag?.content?.active}
          <PricingTag {pricingTag} />
        {/if}
        <h1 class="h1">{@html headline.value}</h1>
        <h2 class="h2">{@html subHeadline.value}</h2>
        <p class="sub-text">{@html description.value}</p>
      </div>
      {#key formSent}
        <Hero3Form
          step={currentStep}
          bind:phoneNumber
          bind:steps={items}
          bind:properties
          on:submitForm={() => (formSent = !formSent)}
        />
      {/key}

      <div class="benefits-list">
        {#each callouts.value as text}
          <div class="benefit">
            <BulletPoint bulletIcon={callouts.icon} />
            <p class="text">
              {@html text}
            </p>
          </div>
        {/each}
      </div>
      <div class="hero-bottom">
        {#if caption?.value}
          <a class="hero-stars-and-reviews" href="#testimonial">
            <p>{@html caption.value}</p>
          </a>
        {/if}
      </div>
    </div>
  </div>
</section>
